import type {CellRendererProps} from '../types/CellRendererProps';

export const getStylesToRender = (cellRendererProps: CellRendererProps) => {
  const column = cellRendererProps.column;
  const data = cellRendererProps.row;

  if (column) {
    return (data[column.key] as {style?: unknown} | null)?.style;
  }
};
